import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=3b4c5770&scoped=true"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=3b4c5770&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c5770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4c5770')) {
      api.createRecord('3b4c5770', component.options)
    } else {
      api.reload('3b4c5770', component.options)
    }
    module.hot.accept("./breadCrumb.vue?vue&type=template&id=3b4c5770&scoped=true", function () {
      api.rerender('3b4c5770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navBar/breadCrumb.vue"
export default component.exports